import React from 'react';

const TermCondition2 = () => {
  const htmlContent = `
  <p style='margin-top:0in;margin-right:0in;margin-bottom:15.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;border:none;padding:0in;'>
        <strong>
          <span style="font-size:15px;font-family:Gulim;color:#454545;">바디스위치 개인정보처리방침</span>
        </strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>&nbsp;</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치는 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야
        할 관련 법규상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에
        최선을 다하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        1. 처리하는 개인정보 항목
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        2. 개인정보의 처리목적
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        3. 개인정보의 제3자 제공
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        4. 개인정보 처리의 위탁
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        5. 개인정보의 처리 및 보유기간
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        6. 개인정보 파기절차 및 방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        7. 이용자 및 법정대리인의 권리와 그 행사방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        8. 개인정보의 안전성 확보조치
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        9. 개인정보 자동수집장치의 설치/운영 및 거부에 관한 사항
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        10. 개인정보보호 책임자 및 연락처
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        11. 정보주체의 권익침해 구제방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        12. 개인정보처리방침의 변경
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>1. 처리하는 개인정보 항목</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 바디스위치는 회원가입, 서비스 제공 및 이용과정에서 아래와 같이 필요한 최소한의 개인정보를 수집하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        가. 필수정보
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -휴대폰 가입: 이름, ID, 비밀번호, 전자메일주소, 전화번호, 생년월일, 성별, 주소
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        나. 선택정보
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 매장 정보: 사업장 이름, 사업자 명, 사업자 번호, 사업장 주소
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 개인맞춤 서비스를 제공하기 위하여 바디스위치가 필요로 하는 기타 정보
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 기기정보
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③ 바디스위치의 개별 서비스 이용, 이벤트 응모 및 경품 신청 과정에서 해당 서비스의 이용자에 한해 추가 개인정보
        수집이 발생할 수 있습니다. 추가로 개인정보를 수집할 경우에는 해당 개인정보 수집 시점에서 이용자에게
        &lsquo;수집하는 개인정보 항목, 개인정보의 수집 및 이용목적, 개인정보의 보관기간&rsquo;에 대해 안내 드리고 동의를
        받으며 아래와 같은 방법으로 개인정보를 수집합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 입력하는 경우
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 제휴 서비스 등으로부터 개인정보를 제공받는 경우
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 고객센터 상담과정에서 수집
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 온/오프라인 이벤트에서 진행되는 이벤트 등 참여
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ※ 정보주체의 수집이용 거부권 및 불이익 고지
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        정보주체는 바디스위치가 수집하는 개인정보의 항목 및 수집 방법에 동의를 거부할 수 있으며, 거부 시 회원에게
        제공되는 서비스 이용의 일부가 제한될 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>2. 개인정보의 처리목적</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 본인인증
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 회원과의 원활한 의사소통 및 문의 접수에 대한 처리결과 회신
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③ 회원으로 가입한 이용자 식별과 가입의사 확인 및 불량회원의 부정한 이용 방지
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ④ 이용자의 관심, 성향의 추정을 통한 맞춤형 콘텐츠 추천 및 마케팅에 활용
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>3. 개인정보의 제3자 제공</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치는 개인정보를 &quot;2. 개인정보의 처리목적&quot;에서 고지한 범위 내에서 사용하며, 정보주체의 사전 동의
        없이는 동 범위를 초과하여 이용하거나 원칙적으로 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는
        예외로 합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 정보주체가 사전에 동의한 경우
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>4. 개인정보 처리의 위탁</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치는 원활한 업무 처리를 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따른 위탁계약 시
        개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.
      </p>
      <table style="border: none;margin-left: 4.2pt;border-collapse: collapse;width: 597px;">
        <tbody>
          <tr>
            <td style="width:68.75pt;border:solid #BFBFBF 1.0pt;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:19.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">수탁업체</span>
              </p>
            </td>
            <td style="width:68.75pt;border:solid #BFBFBF 1.0pt;border-left:none;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:19.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">위탁업무</span>
              </p>
            </td>
            <td style="width:68.8pt;border:solid #BFBFBF 1.0pt;border-left:none;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:19.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">제공항목</span>
              </p>
            </td>
            <td style="width:241.0pt;border:solid #BFBFBF 1.0pt;border-left:  none;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:19.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">개인정보의 보유 및 이용기간</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:68.75pt;border:solid #BFBFBF 1.0pt;border-top:none;padding:0in 4.95pt 0in 4.95pt;height:.5in;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">코리아크레딧뷰로㈜</span>
              </p>
            </td>
            <td style="width:68.75pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0in 4.95pt 0in 4.95pt;height:.5in;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">본인 인증</span>
              </p>
            </td>
            <td style="width:68.8pt;border:none;border-right:solid #BFBFBF 1.0pt;padding:0in 4.95pt 0in 4.95pt;height:.5in;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:center;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">이름</span>
                <span style="font-size:12px;font-family:  Gulim;color:black;">,연락처, 생년월일,성별</span>
              </p>
            </td>
            <td style="width:241.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0in 4.95pt 0in 4.95pt;height:.5in;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:11px;font-family:Gulim;color:black;">
                  업무목적(회원탈퇴 등) 달성 후 지체없이 파기&nbsp;
                </span>
              </p>
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:11px;font-family:Gulim;color:black;">
                  (단, 전자상거래등에서의소비자보호에관한법률에따라 3년간/ 전자상거래등에서의소비자보호에관한법률에따라
                  5년간 보관)
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>5. 개인정보의 처리 및 보유기간</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유/이용 기간 내에서 개인정보를 처리 및 보유하며,
        원칙적으로 개인정보의 처리목적이 달성되면 지체 없이 파기합니다. 단, 이용자에게 개인정보 보관기간에 대해 별도의
        동의를 얻은 경우, 또는 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게
        보관합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에 따라 일정기간 회원정보를 보관합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        [관계법령]
      </p>
      <table style="border: none;width:444.0pt;margin-left:4.2pt;border-collapse:collapse;">
        <tbody>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <strong>
                  <span style="font-size:12px;font-family:Gulim;color:black;">보존항목</span>
                </strong>
              </p>
            </td>
            <td style="width:141.0pt;border:solid #BFBFBF 1.0pt;border-left:  none;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <strong>
                  <span style="font-size:12px;font-family:Gulim;color:black;">근거법령</span>
                </strong>
              </p>
            </td>
            <td style="width:.75in;border:solid #BFBFBF 1.0pt;border-left:none;background:#D9D9D9;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <strong>
                  <span style="font-size:12px;font-family:Gulim;color:black;">보존기간</span>
                </strong>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;border-top:  none;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">계약 또는 청약철회 등에 관한 기록</span>
              </p>
            </td>
            <td style="width:141.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">
                  전자상거래 등에서의&nbsp;
                  <br />
                  &nbsp;소비자 보호에 관한 법률
                </span>
              </p>
            </td>
            <td style="width:.75in;border-top:none;border-left:none;border-bottom:  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:  Gulim;color:black;">5년</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;border-top:  none;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">
                  소비자의 불만 또는 분쟁처리에 관한 기록
                </span>
              </p>
            </td>
            <td style="width:141.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">
                  전자상거래 등에서의&nbsp;
                  <br />
                  &nbsp;소비자 보호에 관한 법률
                </span>
              </p>
            </td>
            <td style="width:.75in;border-top:none;border-left:none;border-bottom:  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:  Gulim;color:black;">3년</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;border-top:  none;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">표시/광고에 관한 기록</span>
              </p>
            </td>
            <td style="width:141.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">
                  전자상거래 등에서의&nbsp;
                  <br />
                  &nbsp;소비자 보호에 관한 법률
                </span>
              </p>
            </td>
            <td style="width:.75in;border-top:none;border-left:none;border-bottom:  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:  Gulim;color:black;">6개월</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;border-top:  none;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">전자금융 거래에 관한 기록</span>
              </p>
            </td>
            <td style="width:141.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">전자금융거래법</span>
              </p>
            </td>
            <td style="width:.75in;border-top:none;border-left:none;border-bottom:  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:  Gulim;color:black;">5년</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:249.0pt;border:solid #BFBFBF 1.0pt;border-top:  none;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">서비스 방문 기록</span>
              </p>
            </td>
            <td style="width:141.0pt;border-top:none;border-left:none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:Gulim;color:black;">통신비밀보호법</span>
              </p>
            </td>
            <td style="width:.75in;border-top:none;border-left:none;border-bottom:  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;background:white;padding:0in 4.95pt 0in 4.95pt;height:16.5pt;">
              <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
                <span style="font-size:12px;font-family:  Gulim;color:black;">3개월</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>6. 개인정보 파기절차 및 방법</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 개인정보는 원칙적으로 개인정보의 처리목적이 달성되면 지체 없이 파기합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 바디스위치는 &lsquo;개인정보 유효기간제&rsquo;에 따라 1년 동안 바디스위치의 서비스를 이용하지 않은 이용자의
        개인정보는 &lsquo;정보통신망 이용촉진 및 정보보호 등에 관한 법률 제29조&rsquo;에 근거하여 이용자에게
        사전통지하고 개인정보를 파기하거나 별도로 분리하여 저장합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 장기 미 이용 이용자의 개인정보는 별도로 분리되어 안전하게 보관하게 되며, 바디스위치 웹/앱 로그인 시
        안내됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 장기 미 이용 이용자는 미 이용자 DB 별도로 분리되기 전에 계속 서비스를 이용하고자 하는 경우 바디스위치 웹/앱에
        로그인 하시면 됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 장기 미 이용 이용자는 바디스위치 웹/앱에 로그인할 경우 이용자의 동의에 따라 본인의 계정을 복원할 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 분리 보관된 개인정보는&nbsp;1년간 보관 후 지체 없이 파기합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③ 개인정보의 파기절차 및 방법은 다음과 같습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        가. 파기절차
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 정보주체가 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련
        법령에 의한 보관사유에 따라(&quot;5. 개인정보의 처리 및 보유기간&quot; 참조) 일정 기간 저장된 후 파기됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        나. 파기방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        - 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>7. 이용자 및 법정대리인의 권리와 그 행사방법</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 정보주체는 바디스위치에 대해 언제든지 다음 각호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -개인정보 열람 요구
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -오류 등이 있을 경우 정정 요구
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -삭제 요구
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -처리정지 요구
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 제1항에 따른 권리 행사는 바디스위치에 대해 전화, 전자우편 등을 통하여 하실 수 있으며 바디스위치는 이에 대해
        지체 없이 조치하겠습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -어플리케이션을 통한 열람, 수정 및 회원 탈퇴 방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        이용자는 언제든지 &quot;마이페이지&nbsp;&gt; 개인정보수정&quot;에서 자신의 개인정보를 조회하거나 수정할 수
        있습니다. 이용자는 언제든지&nbsp;&quot;마이페이지&nbsp;&gt; 개인정보수정&quot;&gt; 회원탈퇴&quot; 등을 통해
        개인정보의 수집 및 이용 동의를 철회할 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        -전화, 전자우편을 통한 열람, 수정 및 회원 탈퇴 방법
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        고객센터: <span style="font-size:12px;font-family:Gulim;color:#222222;">031-411-0715</span>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에 바디스위치는 정정 또는 삭제를 완료할 때까지
        당해 개인정보를 이용하거나 제공하지 않습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ④제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우
        개인정보 보호법 시행규칙 별지 제 11호 서식에 따른 위임장을 제출하셔야 합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ⑤정보주체는 개인정보보호법 등 관계법령을 위반하여 바디스위치가 처리하고 있는 정보주체 본인이나 타인의 개인정보
        및 사생활을 침해하여서는 아니 됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>8. 개인정보의 안전성 확보조치</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치는 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를
        위하여 기술적, 관리적, 물리적 조치를 하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 개인정보 처리 직원의 최소화 및 교육
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로
        갱신하고 있으며, 담당자에 대한 수시 교육을 수행하며, 개인정보보호를 강조하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 비인가자에 대한 출입 통제
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        개인정보를 수집 후 보관하고 있는 개인정보시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립,
        운영하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③ 개인정보보호전담기구의 운영
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        사내 개인정보보호전담기구 등을 통하여 바디스위치의 개인정보처리방침 이행사항 및 담당자의 준수여부를 확인하여
        문제가 발견될 경우 즉시 수정하고 바로잡을 수 있도록 노력하고 있습니다. 단, 바디스위치가 개인정보보호 의무를 다
        하였음에도 불구하고 이용자 본인의 부주의나 바디스위치가 관리하지 않는 영역에서의 사고 등 바디스위치의 귀책에
        기인하지 않은 손해에 대해서는 바디스위치는 책임을 지지 않습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ④ 해킹 등에 대비한 대책
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        바디스위치는 해킹이나 컴퓨터 바이러스 등에 의해 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고
        있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의
        개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를
        안전하게 전송할 수 있도록 하고 있습니다. 또한 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를
        갖추려 노력하고 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>9. 개인정보 자동수집장치의 설치/운영 및 거부에 관한 사항</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ① 바디스위치는 웹 기반 서비스 제공을 위하여 쿠키를 이용하는 경우가 있습니다. 쿠키는 보다 빠르고 편리한 이용을
        지원하기 위해 사용됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;쿠키란 바디스위치 어플리케이션을 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트
        파일로서 이용자 컴퓨터에 저장됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ② 쿠키 사용목적은 이용자의 취향과 관심분야를 파악하여 개인형 맞춤화 된 서비스를 제공하기 위해 사용합니다.
        이용자가 어플리케이션을 실행 할 경우 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어 이용자의
        환경설정을 유지하고 최적화된 서비스를 제공하게 됩니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ③ 쿠키에는 개인을 식별하는 이름, 전화번호 등을 저장하지 않으며, 이용자는 쿠키 설치에 대한 선택권을 가지고
        있습니다. 따라서 이용자는 사용하고 있는 디바이스에서 옵션을 설정하므로 모든 쿠키를 허용하거나, 저장될 때마다
        확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 이용자가 쿠키 설치를 거부하였을 경우 서비스 제공에
        어려움이 있을 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>10. 개인정보보호 책임자 및 연락처</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        귀하께서는 바디스위치를 이용하시는 과정에서 발생하는 모든 개인정보보호 관련 민원을 개인정보보호 책임자에게
        신고하실 수 있습니다. 바디스위치는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        개인정보보호 책임자
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        이 름: 구자창
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        메 일: kjc@clevertegy.co.kr
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>11. 정보주체의 권익침해 구제방법</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        개인정보 침해에 대한 피해구제, 상담 등이 필요하신 경우는 아래 기관에 문의하실 수 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        개인정보침해신고센터 ( http://privacy.kisa.or.kr / 국번없이 118 )
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        대검찰청 사이버수사과 ( http://www.spo.go.kr / 국번없이 1301 )
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        경찰청 사이버안전국 ( http://www.police.go.kr/www/security/cyber.jsp / 국번없이 182 )
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>12. 개인정보처리방침의 변경</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 어플리케이션
        &apos;공지사항&apos;을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의
        중요한 변경이 있을 경우에는 최소 30일전에 고지합니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        공고 일자: 2023년&nbsp;3월&nbsp;1일
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:0in;text-align:left;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        시행 일자: 2023년 3월 1일
      </p>
  `;

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default TermCondition2;
